import React, { memo, useCallback } from "react";

//types
import { IRemovePlanMessage, PlanDetails } from "@swiggy-private/cart-types";

//component
import PlanRemoveConfirmationBottomsheetV2 from "./PlanRemoveConfirmationBottomsheetV2";
import { ErrorBoundary } from "@swiggy-private/core-ui";

//dls
import {
    PlanRemoveConfirmationBottomsheet,
    PlanPurchaseConfirmationProps,
} from "@swiggy-private/dls-web-recipe-common-web/dist/components/SwiggyOne";

//constants
import { VARIANT } from "./constants";

//internal deps
import { getNRErrorInfo, isEmpty } from "@swiggy-private/js-utils";
import { NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";

interface IPlanRemoveConfirmationBottomsheetWrapper {
    removePlanMessage: IRemovePlanMessage;
    bottomSheetProps: PlanPurchaseConfirmationProps;
    planDetails?: PlanDetails;
}
const PlanRemoveConfirmationBottomsheetWrapper = ({
    removePlanMessage,
    bottomSheetProps,
    planDetails,
}: IPlanRemoveConfirmationBottomsheetWrapper) => {
    const onError = useCallback((error?: Error, errorInfo?: React.ErrorInfo) => {
        const errorEvents = getNRErrorInfo(error, errorInfo);

        recordNREvent({
            eventType: NEWRELIC_TABLES.CHECKOUT_WEB_ERROR_BOUNDARY,
            widgetType: "PLAN_REMOVAL_BOTTOMSHEET",
            ...errorEvents,
        });
    }, []);

    if (isEmpty(removePlanMessage)) {
        recordNREvent({
            eventType: NEWRELIC_TABLES.EMPTY_REMOVE_PLAN_MESSAGE,
        });
        return null;
    }

    return (
        <ErrorBoundary errorContent={null} errorFallback={onError}>
            {!isEmpty(removePlanMessage?.variant) && removePlanMessage.variant === VARIANT.ANIMATION ? (
                <PlanRemoveConfirmationBottomsheetV2
                    primaryCTAHandler={bottomSheetProps.ctas.primaryCTA.handler}
                    secondaryCTAHandler={bottomSheetProps.ctas.secondaryCTA.handler}
                    removePlanMessage={removePlanMessage}
                    planDetails={planDetails}
                />
            ) : (
                <PlanRemoveConfirmationBottomsheet {...bottomSheetProps} />
            )}
        </ErrorBoundary>
    );
};

export default memo(PlanRemoveConfirmationBottomsheetWrapper);
